"use client";
import React from "react";
import GoogleMapReact from "google-map-react";
import NextLink from "next/link";
import LazyLoad from "react-lazyload";

interface MarkerProps {
  lat: number;
  lng: number;
}

const Marker = (_props: MarkerProps) => (
  <div className="rounded-full bg-teal-400 w-4 h-4" />
);

/**
 * TODO: Upload with this https://react.dev/reference/react/lazy
 */
export default function GoogleMap({
  lat,
  lng,
  mapsUrl,
}: {
  lat: number;
  lng: number;
  mapsUrl: string | null;
}) {
  const defaultProps = {
    center: {
      lat,
      lng,
    },
    zoom: 16,
  };

  return (
    <LazyLoad height="380px" once>
      <div>
        <div className="block h-[380px] w-full pt-8">
          <GoogleMapReact
            apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
          >
            <Marker lat={lat} lng={lng} />
          </GoogleMapReact>
        </div>
      </div>
    </LazyLoad>
  );
}
